// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Evul9bM2v6233k_Vnquy{line-height:1.5rem;margin-bottom:20px;flex:1 0 auto;position:relative;overflow:hidden}.JhxGv3gmIdG6Lc2hQRUg{text-align:center;color:var(--color-default);font-size:1rem;display:block;padding:5px;line-height:1.5rem}.JhxGv3gmIdG6Lc2hQRUg img{max-width:164px;max-height:28px;margin:8px 5px 0}.vZzMOxo2jiSFVl1v1jD8{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden}.vZzMOxo2jiSFVl1v1jD8>img{width:100%;height:100%}.vZzMOxo2jiSFVl1v1jD8 .k2REz_wzVEerIVDaC_cD img{max-width:100%}.mLo_Q39TDL7Wa21GVMWw{height:100%;position:relative;margin-right:-12px}.mLo_Q39TDL7Wa21GVMWw .EYIpYOA0vHCX8zKMNxAL{display:flex;min-height:100%;flex-direction:column;justify-content:stretch}.ZQBmE1mtGsolAhx54XnU .f5qNqebkoPz7JypkPcSW{display:flex}.ZQBmE1mtGsolAhx54XnU .f5qNqebkoPz7JypkPcSW .JbY7w1X4LDDNjQEpStrn{padding:7px 0;flex:1 1 auto}.ZQBmE1mtGsolAhx54XnU .ZvIxeGne_knMCOfFTicL{margin-bottom:12px;margin-top:2px}.Pe6FeoZ5cCg2MHu5CxyL{flex:0 0 auto}.Pe6FeoZ5cCg2MHu5CxyL img{max-width:109px;width:100%;border-radius:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"accordion": `Evul9bM2v6233k_Vnquy`,
	"collaboration": `JhxGv3gmIdG6Lc2hQRUg`,
	"content": `vZzMOxo2jiSFVl1v1jD8`,
	"carouselItem": `k2REz_wzVEerIVDaC_cD`,
	"leftPanel": `mLo_Q39TDL7Wa21GVMWw`,
	"leftPanelWrapper": `EYIpYOA0vHCX8zKMNxAL`,
	"interviews": `ZQBmE1mtGsolAhx54XnU`,
	"entry": `f5qNqebkoPz7JypkPcSW`,
	"text": `JbY7w1X4LDDNjQEpStrn`,
	"bioButtonWrapper": `ZvIxeGne_knMCOfFTicL`,
	"videoThumb": `Pe6FeoZ5cCg2MHu5CxyL`
};
export default ___CSS_LOADER_EXPORT___;
